import { getCalendarLabelByMode } from '@modules/common/components/DateRangePicker/CalendarPicker/helpers';
import { getDateRange } from '@modules/common/components/DateRangePicker/helpers';
import { useGetDefaultTenantTimeRange } from '@modules/common/hooks';
import { useFeedStore } from '@modules/feed/store/feedStore';
import { Grid, Typography } from '@mui/material';

export const FeedDurationDefinitionInfo = () => {
  const searchQuery = useFeedStore(({ query }) => query);
  const defaultTimeRange = useGetDefaultTenantTimeRange();

  const [from, to] = getDateRange(searchQuery.duration ?? defaultTimeRange);
  const durationDisplayText = getCalendarLabelByMode(
    [from, to],
    searchQuery.duration ?? defaultTimeRange,
    '--',
  );

  return (
    <>
      <Grid item xs={3}>
        <Typography variant="caption" color="inherit">
          Duration:
        </Typography>
      </Grid>
      <Grid item xs={9}>
        <Typography variant="caption" color="inherit">
          {durationDisplayText}
        </Typography>
      </Grid>
    </>
  );
};
